import { toNumber } from 'lodash-es'
import { mapGetters } from 'vuex'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

export default {
  computed: {
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      ticketType: FORM_GETTER.SWITCHABLE_RETURN_TYPES,
      workingTimeRemuneration: FORM_GETTER.WORKING_TIME_COMPENSATION,
    }),
    isEngineForm() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.ENGINE
    },
    isBuyEngineForm() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BUY_ENGINE
    },
    isWorkingTimeRemunerationForm() {
      return !!(this.isEngineForm && toNumber(this.workingTimeRemuneration))
    },
    isBatteryForm() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BATTERY
    },
    isComponentsForm() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.COMPONENT
    },
    isTutorialPath() {
      return false
      // return this.isEngineForm || this.isBuyEngineForm || this.isComponentsForm
    },
    // tutorialTranslationType() {
    //   switch (this.ticketType) {
    //     case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.ENGINE: {
    //       return 'engine'
    //     }
    //     case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BUY_ENGINE: {
    //       return 'buyEngine'
    //     }
    //     case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BATTERY: {
    //       return 'battery'
    //     }
    //     case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.COMPONENT: {
    //       return 'components'
    //     }

    //     default: {
    //       return ''
    //     }
    //   }
    // },
    ticketTranslationType() {
      switch (this.ticketType) {
        case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.ENGINE: {
          return 'engine'
        }
        case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BUY_ENGINE: {
          return 'engine'
        }
        case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.BATTERY: {
          return 'battery'
        }
        case FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.COMPONENT: {
          return 'components'
        }

        default: {
          return ''
        }
      }
    },
    /** Paths */
    translationComplaintFormPath() {
      return 'complaintForm'
    },
    translationTicketPath() {
      return `${this.translationComplaintFormPath}.ticket`
    },
    translationTicketTypePath() {
      return `${this.translationTicketPath}.${this.ticketTranslationType}`
    },
    translationTicketErrorPath() {
      return `${this.translationTicketPath}.error`
    },
    translationTicketTypeErrorPath() {
      return `${this.translationTicketTypePath}.error`
    },
  },
}
